import '../styles/LinkPreview.css'

export const VideoPreview = ({ onClick }) => (
  <div
    className="media-preview retro-video-preview"
    onClick={onClick}
  >
    ▶️
  </div>
);

export const MusicPreview = ({ onClick }) => (
  <div
    className="media-preview retro-music-preview"
    onClick={onClick}
    
  >
    🎵
  </div>
);
